<!--
HS코드 선택기 > 수동등록 > hs코드 안내사항
-->
<template>
    <div class="">

        <!-- HS코드 000000 안내 -->
        <div class="hscode-notice">
            <div class="hscode-notice-inner">
                <span uk-icon="icon: info; ratio: 0.9" class="hscode-notice-icon"></span>
                <span>
                    배송신청서 등록시 HS 코드중
                    <code class="hscode-notice-code">000000</code>
                    은 사용하지 마시고, 품목에 맞는 HS 코드를 선택해 주시기 바랍니다.
                </span>
            </div>
        </div>

        <div class="detail-search">
            <div class="border-box uk-padding-small uk-text-left">
                <i class="material-icons">info</i>
                위 목록에서 검색되지 않는 품목은 상세검색 후 6자리 코드를 직접입력하세요.
                <div class="uk-flex uk-flex-between uk-margin-small-top">
                    <a href="https://www.bandtrass.or.kr/hsnavi.do?page=F&site=#table_content"
                       class="uk-button uk-button-primary uk-button-small" target="_blank">
                        <i class="material-icons">forward</i>
                        HS코드 상세검색
                    </a>

                    <a href="https://global.gonelo.com/common/faqs/170" target="_blank"
                       class="uk-button uk-button-small uk-button-dark">
                        자세히읽기<i class="material-icons">open_in_new</i>
                    </a>
                </div>

            </div>

        </div>


    </div>


</template>

<script>

export default {
    components: {

    },

    props: {


    },
    data: function () {
        return {};
    },
    computed: {



    },
    methods: {



    },


}
</script>

<style lang="scss" scoped>

.hscode-notice {
    border-left: 4px solid #1e87f0;
    background-color: #f8f8f8;
    border-radius: 4px;
    padding: 10px 14px;
    margin-bottom: 0.75rem;

    .hscode-notice-inner {
        display: flex;
        align-items: flex-start;
        font-size: 1.125rem;
        line-height: 1.6;
        color: #333;
    }

    .hscode-notice-icon {
        color: #1e87f0;
        flex-shrink: 0;
        margin-right: 8px;
        margin-top: 1px;
    }

    .hscode-notice-code {
        background: #fff3cd;
        padding: 1px 6px;
        border-radius: 3px;
        font-weight: bold;
        color: #856404;
    }
}

.detail-search {
    margin-bottom: 1rem;
}
.guide {
    margin-bottom: 1rem;
}
</style>